import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';
import ROUTES from 'Utilities/routes';

const { BIDDING } = ANALYTICS_CATEGORIES;

const { CTA_CLICKED } = SNOWPLOW_EVENTS;

interface TriggerConfirmCancelBidOrOfferCTAClickedEventParams {
	bidAmount?: string;
	errorMessage?: string;
	success: boolean;
}

export const triggerSubmitBidConfirmationCTAClickedEvent = ({
	bidAmount,
	errorMessage,
	success,
}: TriggerConfirmCancelBidOrOfferCTAClickedEventParams): void => {
	const eventPayload = getSnowplowEventPayload({
		category: BIDDING,
		customData: {
			button_label: `Submit bid`,
			label: success ? `${bidAmount}` : errorMessage,
			success,
			url: ROUTES.VEHICLE.as(),
		},
		name: `dlr_submit_bid_button_clicked`,
		schemaName: CTA_CLICKED.SCHEMA,
		version: CTA_CLICKED.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
